// @ts-ignore
import { DataConnection, Peer } from 'peerjs/dist/peerjs.esm.js'; // temporary fix until we can build this correctly with Webpack
// import PeerJs from 'peerjs';

/**
 * Enables communication with the parent window hosted in a Learning Management System
 */
export class LmsClient {
	private _parentPeerId: string
	private _peer: Peer
	private _connection: DataConnection

	constructor(parentPeerId: string) {
		this._parentPeerId = parentPeerId;
		this._peer = new Peer();
		this._connection = this._peer.connect(this._parentPeerId);
	}

	initialize() {
		return this._connection.send('{"action": "initialize", "value": ""}')
	}

	terminate() {
		return this._connection.send('{"action": "terminate", "value": ""}')
	}

	setCompletion(completed: boolean) {
		const res = this._connection.send(`{"action": "setCompletion", "value": ${completed}}`)
		if (completed) return this.terminate()
		return res
	}

	setSuccess(passed: boolean) {
		return this._connection.send(`{"action": "setSuccess", "value": ${passed}}`)
	}

	setProgress(progress: number) {
		if (progress < 0 || progress > 1) throw 'Progress value should be between 0 and 1'
		return this._connection.send(`{"action": "setProgress", "value": ${progress}}`)
	}
}

export function getLmsClient() {
    // Get the LMS peer ID from the URL
    const url = new URL(document.location.toString());
    const parentPeerId = url.searchParams.get('lmshp');
    if (typeof parentPeerId !== 'string') {
        console.warn('LMS peer ID missing in the URL: "lmshp"')
        return;
    }
	return new LmsClient(parentPeerId)
}
